const customFilterStyles = {
  SearchComponent: {
    width: "430px",
    maxWidth: "100%",
  },
  searchComponentContainer: {
    marginBottom: 2,
    marginLeft: "35px",
    flex: "1 1x",
    minWidth: 0,
  },
  filterContainer: {
    display: "flex",
  },
};

export default customFilterStyles;
